import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import PostsService from '../services/PostsService';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const toast = React.useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const success = await PostsService.login(username, password);
      if (success) {
        onLogin();
        toast.current.show({
          severity: 'success',
          summary: 'Success',
          detail: 'Login successful',
          life: 3000
        });
      }
    } catch (error) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Invalid username or password',
        life: 3000
      });
    }
    setLoading(false);
  };

  return (
    <div className="flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Toast ref={toast} />
      <Card className="w-6">
        <h2 className="text-center mb-4">Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="field mb-3">
            <label htmlFor="username" className="block mb-2">Username</label>
            <InputText
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full"
              required
            />
          </div>
          <div className="field mb-4">
            <label htmlFor="password" className="block mb-2">Password</label>
            <Password
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full"
              inputClassName="w-full"
              feedback={false}
              required
            />
          </div>
          <Button
            type="submit"
            label={loading ? 'Logging in...' : 'Login'}
            className="w-full"
            loading={loading}
          />
        </form>
      </Card>
    </div>
  );
};

export default Login; 